<template>
  <div class="container" v-if="is_visible">
    <div class="overlay" @click="closeModal"></div>
    <div class="prato-container">
      <span class="tit">
        {{ $t('dish_details') }}
        <span class="cell-location-tags" v-if="modalDateLabel || modalColumnLabel">
          <span class="location-tag" v-if="modalDateLabel">
            {{ $t('row_label') }}: {{ modalDateLabel }}
          </span>
          <span class="location-tag" v-if="modalColumnLabel">
            {{ $t('column_label') }}: {{ modalColumnLabel }}
          </span>
        </span>
      </span>

      <div class="modal-body">
        <div class="prato" v-if="coluna.id_prato && !exchangePlate && !copyDiners">
          <div class="compare-card detail-card main-detail-card">
            <div class="detail-fields">
              <div
                class="detail-field"
                v-for="(tit,titkey) in gridDetail"
                :key="`main-${titkey}`"
              >
                <span class="field-label" v-text="label[tit] || tit"></span>
                <span class="field-value" :title="getPlateValue(tit, coluna?.id_prato)" v-text="getPlateValue(tit, coluna?.id_prato) || '-'"></span>
              </div>
            </div>
            <div class="main-consumption" v-if="exchangePlate == false">
              <label class="main-consumption-label" for="percConsumo">{{$t('percentage_of_consumption')}}:</label>
              <input
                class="input-number"
                name="percConsumo"
                type="number"
                step="0.15"
                v-if="!coluna?.isFrozenDay"
                :disabled="copyDiners"
                v-model="formattedPercentual"
                @input="markInputChanged"
                @focus="saveOldValue"
              />
              <span
                v-if="coluna?.isFrozenDay"
                class="main-consumption-value"
                :title="coluna.perc_consumo"
                v-text="coluna.perc_consumo"
              />
            </div>
            <div class="frequencias" v-if="getFrequencyInfo(coluna?.id_prato) != ''" v-html="getFrequencyInfo(coluna?.id_prato)"></div>
          </div>
        </div>

        <div class="plate-exchage" v-if="exchangePlate && copyDiners !== true">
          <div class="exchange-layout">
            <div class="exchange-list">
              <div class="filter-input">
                <input
                  type="text"
                  v-model="filterText"
                  @input="applyFilter"
                  placeholder="Digite para filtrar pratos"
                />
              </div>
              <div class="sub-container-headline">
                <span>{{ $t('group_') }}</span>
                <span>{{ $t('cod') }}</span>
                <span>{{ $t('plate') }}</span>
              </div>
              <div class="sub-container">
                <div
                  class="plate"
                  v-for="(plate, key) in filteredPlates"
                  :key="key"
                  @click="loadDetail(plate)"
                  :class="{'active': chossPlate?.id_prato === plate.id_prato}"
                >
                  <span v-for="(tit,titkey) in gridTit" :key="titkey" v-text="plate[tit]"></span>
                  <span v-if="hasValidations(plate)" class="validation-alert">!</span>
                </div>
              </div>
            </div>

            <div class="exchange-preview">
              <div class="compare-card detail-card" v-if="chossPlate">
                <h4 class="compare-title">{{ $t('selected_plate') }}</h4>
                <div class="detail-fields">
                  <div
                    class="detail-field"
                    v-for="(tit,titkey) in gridDetail"
                    :key="`selected-${titkey}`"
                  >
                    <span class="field-label" v-text="label[tit] || tit"></span>
                    <span class="field-value" :title="getPlateValue(tit, chossPlate.id_prato)" v-text="getPlateValue(tit, chossPlate.id_prato) || '-'"></span>
                  </div>
                </div>
                <div class="frequencias" v-if="frequenciasPrato != ''" v-html="frequenciasPrato"></div>
              </div>

              <div class="compare-card selection-placeholder" v-else>
                <h4>{{ $t('select_a_plate') }}</h4>
                <p>{{ $t('click_on_a_dish_to_view_details') }}</p>
              </div>
            </div>

          </div>
        </div>

        <div class="copy-diners" v-if="copyDiners">
          <div class="sub-container copy-diners-content">

            <header class="sub-container-header">
              <h4 v-text="''+$t('copy_by')+':'"/>
              
              <div class="radio-btn">
                <input type="radio" id="percent" value="percent" v-model="pickedRadioChoice"/>
                <label for="percent" class="labelForRadio" v-text="$t('consumption_percentage')" />
              </div>

              <div class="radio-btn">
                <input type="radio" id="number" value="number" v-model="pickedRadioChoice"/>
                <label for="number" class="labelForRadio" v-text="$t('number_of_diners')" />
              </div>

              <input
                class="input-number"
                name="cpyConsumo"
                type="number"
                :step="pickedRadioChoice === 'percent' ? 0.15 : 1"
                v-model="copyValue"
              />
            </header>

            <section class="sub-container-content">
                <h4 v-text="$t('exceptions')"/>
                <div class="exceptions">
                  <div v-for="day in daysOfWeek" :key="day.key" class="exception-item">
                    <label :for="day.key" class="weekDay">{{ day.name }}</label>
                    <input
                      class="input-number"
                      type="number"
                      :id="day.key"
                      :step="pickedRadioChoice === 'percent' ? 0.15 : 1"
                      v-model="exceptions[day.key]"
                    />
                  </div>
                </div>
              </section>
          </div>
        </div>
      </div>

      <div class="button-container action-toolbar">
        <button
            v-if="currentPlateValidations.length > 0 && this.exchangePlate"
            class="hasprato"
            @click="showPlateValidations"
          >
            <i class="fas fa-exclamation-circle"></i> {{ $t('ver_validacoes') }}
        </button>
        <button v-text="''+$t('cancel')+''" class="hasprato" @click="clearPlate"></button>
        
        <button
          v-text="''+$t('delete_plate')+''"
          class="hasprato"
          v-if="coluna?.id_prato != null && !coluna?.isFrozenDay && copyDiners !== true"
          @click="deletePlate"
        ></button>

        <button
          v-text="''+$t('change_plate')+''"
          class="hasprato"
          v-if="exchangePlate == false && otherOptions.length > 0 && copyDiners !== true"
          @click="exchangePlate = true"
        ></button>

        <button
          v-text="''+$t('copy_diners')+''"
          class="hasprato"
          v-if="coluna?.id_prato && copyDiners !== true"
          @click="handleCopyDiners(coluna)"
        ></button>

        <button
          v-text="''+$t('apply')+''"
          v-if="!copyDiners"
          :disabled="!isApplyEnabled"
          :class="{'hasprato': isApplyEnabled}"
          @click="editarprato"
        ></button>

        <button
          v-text="''+$t('apply')+''"
          v-if="copyDiners"
          :class="{'hasprato': isCopyDinnersAble()}"
          @click="handleApplyCopyDiners"
        ></button>
      </div>

    </div>
    <div
      v-if="showCurrentPlatePopup"
      class="current-plate-popup"
      :class="{ 'is-collapsed': currentPopupCollapsed, 'is-dragging': isDraggingCurrentPopup }"
      :style="currentPopupStyle"
    >
      <div class="compare-card detail-card current-popup-card">
        <h4 class="compare-title popup-title-row" @mousedown="startCurrentPopupDrag">
          <span>{{ $t('current_plate') }}</span>
          <button
            type="button"
            class="collapse-toggle"
            @mousedown.stop
            @click="toggleCurrentPopup"
          >
            <i :class="currentPopupCollapsed ? 'fas fa-chevron-down' : 'fas fa-chevron-up'"></i>
          </button>
        </h4>
        <div class="detail-fields" v-if="!currentPopupCollapsed">
          <div
            class="detail-field"
            v-for="(tit,titkey) in gridDetail"
            :key="`current-popup-${titkey}`"
          >
            <span class="field-label" v-text="label[tit] || tit"></span>
            <span class="field-value" :title="getPlateValue(tit, coluna?.id_prato)" v-text="getPlateValue(tit, coluna?.id_prato) || '-'"></span>
          </div>
        </div>
        <div class="frequencias" v-if="!currentPopupCollapsed && getFrequencyInfo(coluna?.id_prato) != ''" v-html="getFrequencyInfo(coluna?.id_prato)"></div>
      </div>
    </div>

    <FeedbackConfirmationModal
      :categoria="applyFeedback.categoria"
      :motivo="applyFeedback.motivo"
      :showError="showConfirmationError"
      @updateCategoria="applyFeedback.categoria = $event"
      @updateMotivo="applyFeedback.motivo = $event"
      @confirm="handleConfirmationConfirm"
      @cancel="handleConfirmationCancel"
      @showError="showConfirmationError = true"
      @clearError="showConfirmationError = false"
    />
    <PlateValidationModal :validations="currentPlateValidations" />
  </div>

</template>

<script>
/*global localStorage*/
import PlateSubsController from "../controllers/PlateSubsController";
import { t } from 'i18next';
import moment from 'moment';
import FeedbackConfirmationModal from "./modals/FeedbackConfirmationModal";
import PlateValidationModal from "./modals/PlateValidationModal";

export default {
  name: "PlatesSubstitution",
  components: {
    FeedbackConfirmationModal,
    PlateValidationModal
  },
  data() {
    return {
      cardData: {},
      coluna: {},
      dateIndex: null,
      is_visible: false,
      languageLocale: null,
      applyFeedback: { categoria: "", motivo: "" },
      showConfirmationError: false,
      exceptions: {
        monday: null,
        tuesday: null,
        wednesday: null,
        thursday: null,
        friday: null,
        saturday: null,
        sunday: null,
        holiday: null
      },
      copyDiners: false,
      pickedRadioChoice: 'percent',
      copyValue: null,
      inputChanged: false,
      exchangePlate: false,
      gridTit: ["nm_grupo", "id_prato", "nm_prato"],
      gridDetail: [
        "id_prato",
        "nm_prato",
        "nm_grupo",
        "vlr_prato",
        "id_pre_preparo",
        "utilizacao_prato",
        "nm_atratividade",
        "nm_tipocorte",
        "nm_modopreparo",
        "nm_ingrediente_1",
        "nm_ingrediente_2",
        "nm_proteina",
      ],
      frequenciasPrato: "",
      filterText: "",
      filteredPlates: [],
      otherOptions: [],
      chossPlate: null,
      label: {
        nm_grupo: t('group_'),
        nm_prato: t('plate') + ": ",
        id_prato: t('cod'),
        vlr_prato: t('unit_cost') + t('R$'),
        id_pre_preparo: t('pre_preparation'),
        utilizacao_prato: t('use_'),
        nm_atratividade: t('attractiveness_'),
        nm_tipocorte: t('type_of_cut') + ": ",
        nm_modopreparo: t('method_of_preparation') + ": ",
        nm_ingrediente_1: t('ing_main_1') + ": ",
        nm_ingrediente_2: t('ing_main_2') + ": ",
        nm_proteina: t('type_protein') + ": "
      },
      validationMap: new Map(),
      currentPlateValidations: [],
      old_perc_consumo: null,
      currentPopupStyle: {},
      currentPopupCollapsed: false,
      currentPopupCustomPosition: null,
      isDraggingCurrentPopup: false,
      currentPopupDragOffset: { x: 0, y: 0 }
    };
  },
  mounted() {
    this.languageLocale = localStorage.getItem('lang') || 'pt-BR';
    window.addEventListener('resize', this.updateCurrentPlatePopupPosition);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateCurrentPlatePopupPosition);
    window.removeEventListener('mousemove', this.onCurrentPopupDrag);
    window.removeEventListener('mouseup', this.stopCurrentPopupDrag);
  },
  watch: {
    pickedRadioChoice() {
      if(this.coluna && this.cardData.dataCatalog){
        const percentual = this.coluna.perc_consumo.toFixed(2);
        const qt_comensais = this.cardData.dataCatalog?.tabela?.[this.dateIndex]?.qt_comensais ?? 0;
        const comensais = Math.round(percentual * qt_comensais / 100);
      
        this.copyValue = this.pickedRadioChoice === 'percent' ? percentual : comensais;
        this.resetDaysOfTheWeek();
      }
    },
    is_visible() {
      this.$nextTick(this.updateCurrentPlatePopupPosition);
    },
    exchangePlate() {
      this.$nextTick(this.updateCurrentPlatePopupPosition);
    },
    copyDiners() {
      this.$nextTick(this.updateCurrentPlatePopupPosition);
    },
    chossPlate() {
      this.$nextTick(this.updateCurrentPlatePopupPosition);
    },
    currentPopupCollapsed() {
      this.$nextTick(this.updateCurrentPlatePopupPosition);
    }
  },
  computed: {
    modalDateLabel() {
      return this.cardData?.dataCatalog?.tabela?.[this.dateIndex]?.data || '';
    },
    modalColumnLabel() {
      const columnId = this.coluna?.id_coluna;

      if (columnId === null || columnId === undefined) {
        return '';
      }

      const columnName = this.cardData?.dataCatalog?.colunas?.[columnId]?.nm_tipoprato;
      return columnName;
    },
    highlightedPlateName() {
      if (this.exchangePlate && this.chossPlate?.nm_prato) {
        return this.chossPlate.nm_prato;
      }

      return this.getPlateData('nm_prato', this.coluna?.id_prato) || '';
    },
    daysOfWeek() {
      const currentLocale = moment.locale(this.languageLocale);
      const baseDays = [
        { key: 'monday', name: moment.weekdays(1) },
        { key: 'tuesday', name: moment.weekdays(2) },
        { key: 'wednesday', name: moment.weekdays(3) },
        { key: 'thursday', name: moment.weekdays(4) },
        { key: 'friday', name: moment.weekdays(5) },
        { key: 'saturday', name: moment.weekdays(6) },
        { key: 'sunday', name: moment.weekdays(0) },
        { key: 'holiday', name: t('holidays') }
      ];
    
      // Ajusta nomes para o português, se necessário
      return baseDays.map(day => {
        let translatedName = day.name;
        
        if(translatedName !== t('holidays')){
          if (currentLocale === 'pt-br') {
            translatedName = translatedName.replace('-feira', '') + 's';
          } else {
            translatedName += 's';
          }
        }

        return { key: day.key, name: translatedName };
      });
    },

    formattedPercentual: {
      get() {
        // Retorna o valor formatado para duas casas decimais
        return parseFloat(this.coluna?.perc_consumo).toFixed(2);
      },
      set(newValue) {
        // Converte o novo valor para número e atualiza o plate
        this.coluna.perc_consumo = parseFloat(newValue);
      }
    },
    
    isApplyEnabled() {
      return ((this.exchangePlate === true && !!this.chossPlate) || (this.inputChanged && (this.exchangePlate === false && this.coluna?.id_prato != null && this.coluna?.perc_consumo > 0))
      );
    },

    showCurrentPlatePopup() {
      return this.is_visible && this.exchangePlate && !this.copyDiners && !!this.coluna?.id_prato;
    }
  },
  
  methods: {

    saveOldValue() {
      this.old_perc_consumo = this.coluna.perc_consumo;
    },
    open(coluna, dateIndex, cardData) {
      this.cardData = cardData;
      this.coluna = coluna;
      this.dateIndex = dateIndex;
      this.is_visible = true;
      this.otherOptions = this.loadOtherOptions();
      this.filteredPlates = this.otherOptions;
      this.generateValidationMap();
      this.currentPopupCollapsed = false;
      this.currentPopupCustomPosition = null;
      this.$nextTick(this.updateCurrentPlatePopupPosition);
    },
    toggleCurrentPopup() {
      this.currentPopupCollapsed = !this.currentPopupCollapsed;
    },
    startCurrentPopupDrag(event) {
      if (!this.showCurrentPlatePopup || event.button !== 0) return;

      const popupElement = this.$el?.querySelector('.current-plate-popup');
      if (!popupElement) return;

      const rect = popupElement.getBoundingClientRect();
      this.currentPopupDragOffset = {
        x: event.clientX - rect.left,
        y: event.clientY - rect.top
      };

      this.isDraggingCurrentPopup = true;
      window.addEventListener('mousemove', this.onCurrentPopupDrag);
      window.addEventListener('mouseup', this.stopCurrentPopupDrag);
      event.preventDefault();
    },
    onCurrentPopupDrag(event) {
      if (!this.isDraggingCurrentPopup) return;

      const popupElement = this.$el?.querySelector('.current-plate-popup');
      const popupWidth = popupElement?.offsetWidth || 280;
      const popupHeight = popupElement?.offsetHeight || 220;

      const maxLeft = Math.max(10, window.innerWidth - popupWidth - 10);
      const maxTop = Math.max(10, window.innerHeight - popupHeight - 10);

      const nextLeft = Math.min(maxLeft, Math.max(10, event.clientX - this.currentPopupDragOffset.x));
      const nextTop = Math.min(maxTop, Math.max(10, event.clientY - this.currentPopupDragOffset.y));

      this.currentPopupCustomPosition = {
        left: nextLeft,
        top: nextTop
      };

      this.updateCurrentPlatePopupPosition();
      event.preventDefault();
    },
    stopCurrentPopupDrag() {
      if (!this.isDraggingCurrentPopup) return;

      this.isDraggingCurrentPopup = false;
      window.removeEventListener('mousemove', this.onCurrentPopupDrag);
      window.removeEventListener('mouseup', this.stopCurrentPopupDrag);
    },
    updateCurrentPlatePopupPosition() {
      if (!this.showCurrentPlatePopup) {
        this.currentPopupStyle = {};
        this.stopCurrentPopupDrag();
        return;
      }

      const mainModal = this.$el?.querySelector('.prato-container');
      if (!mainModal) return;

      const rect = mainModal.getBoundingClientRect();
      const gap = 12;
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      const minPopupWidth = this.currentPopupCollapsed ? 220 : 260;
      const maxPopupWidth = 360;
      const availableLeft = Math.max(0, rect.left - gap);
      const availableRight = Math.max(0, viewportWidth - rect.right - gap);
      const fitsLeftSide = availableLeft >= minPopupWidth;
      const fitsRightSide = availableRight >= minPopupWidth;

      const chosenSpace = fitsLeftSide ? availableLeft : availableRight;
      const popupWidth = Math.min(maxPopupWidth, Math.max(minPopupWidth, chosenSpace || minPopupWidth));
      const useLeftSide = fitsLeftSide || (!fitsRightSide && availableLeft >= availableRight);
      const safeTop = Math.max(10, Math.min(rect.top, viewportHeight - 280));
      const dynamicLeft = rect.left - popupWidth + 20;

      let left = useLeftSide ? Math.max(10, dynamicLeft) : rect.right;
      let top = safeTop;

      if (this.currentPopupCustomPosition) {
        const maxLeft = Math.max(10, viewportWidth - popupWidth - 10);
        const maxTop = Math.max(10, viewportHeight - (this.currentPopupCollapsed ? 52 : 260) - 10);
        left = Math.min(maxLeft, Math.max(10, this.currentPopupCustomPosition.left));
        top = Math.min(maxTop, Math.max(10, this.currentPopupCustomPosition.top));
      }

      this.currentPopupStyle = {
        top: `${top}px`,
        left: `${left}px`,
        right: 'auto',
        width: `${popupWidth}px`,
        maxHeight: this.currentPopupCollapsed
          ? '52px'
          : `${Math.max(260, Math.min(rect.height, viewportHeight - 20))}px`
      };
    },
    loadOtherOptions() {
      const list_plates = this.coluna?.pratos_disponiveis || [];
      const pratos = this.cardData?.dataCatalog?.pratos;
      const grupos = this.cardData?.dataCatalog?.grupos;

      if (!list_plates.length || !pratos || !grupos) return [];

      return list_plates
        .map(id => {
          const prato = pratos[id];
          if (!prato) return null;

          const grupo = grupos[prato.id_grupo];
          if (!grupo) return null;

          return {
            id_grupo: grupo.id_grupo,
            nm_grupo: grupo.nm_grupo,
            id_prato: prato.id_prato,
            nm_prato: prato.nm_prato
          };
        })
        .filter(Boolean);
    },
    generateValidationMap() {
      const map = new Map();
      if(this.otherOptions?.length){
        for (const option of this.otherOptions){
          const validations = PlateSubsController.getPlateValidations(option, this.coluna, this.dateIndex, this.cardData.dataCatalog);
          map.set(option.id_prato, validations ?? []);
        }
      }
      this.validationMap = map;
    },    

    hasValidations(plate) {
      if (!plate?.id_prato) return false;
      const validations = this.validationMap.get(plate.id_prato);
      return Array.isArray(validations) && validations.length > 0;
    },

    showPlateValidations() {
      this.$modal.show("plateValidationModal");
    },

    markInputChanged() {
      this.inputChanged = true;
    },
  
  
    resetDaysOfTheWeek() {
      this.exceptions = {
        monday: null,
        tuesday: null,
        wednesday: null,
        thursday: null,
        friday: null,
        saturday: null,
        sunday: null,
        holiday: null
      };
    },

    handleApplyCopyDiners() {
      const dataCatalog = this.cardData?.dataCatalog;
      const coluna = this.coluna;
      if(!dataCatalog || !coluna ) return;

      Object.keys(this.exceptions).forEach(day => {
        if (this.exceptions[day] === null) {
          this.exceptions[day] = this.copyValue;
        }
      });

      PlateSubsController.updateCopiaComenais(dataCatalog, coluna, this.exceptions, this.pickedRadioChoice);

      const tabelaAtual = dataCatalog?.tabela;
      const temTabela = Array.isArray(tabelaAtual) && tabelaAtual.length > 0;
      if (temTabela) {
        dataCatalog.Eventos = [];
        dataCatalog.Eventos = PlateSubsController.generateScenarioEvents(tabelaAtual, this.applyFeedback.categoria, this.applyFeedback.motivo);
      }
      this.$emit("updateCenarioFromPlateSub", this.cardData);
      this.clearPlate();
      this.closeModal();
    },
    handleCopyDiners(coluna) {
      this.copyDiners = true;
      this.copyValue = coluna.perc_consumo.toFixed(2);
    },
    
    isCopyDinnersAble() {
      return this.pickedRadioChoice !== null && this.copyValue > 0;
    },
    
    applyFilter() {
      const text = this.filterText.toLowerCase();
      if (!text) {
        this.filteredPlates = this.otherOptions;
        return;
      }
    
      this.filteredPlates = this.otherOptions.filter((plate) => {
        const { nm_grupo, nm_prato, id_prato } = plate;
    
        // "Contém" (texto entre % %)
        if (text.startsWith('%') && text.endsWith('%')) {
          const searchTerm = text.slice(1, -1);
          return (
            nm_grupo.toLowerCase().includes(searchTerm) ||
            nm_prato.toLowerCase().includes(searchTerm) ||
            id_prato.toLowerCase().includes(searchTerm)
          );
        }
    
        // "Termina com" (texto começa com %)
        if (text.startsWith('%')) {
          const searchTerm = text.slice(1);
          return (
            nm_grupo.toLowerCase().endsWith(searchTerm) ||
            nm_prato.toLowerCase().endsWith(searchTerm) ||
            id_prato.toLowerCase().endsWith(searchTerm)
          );
        }
    
        // "Inicia com" (padrão ou texto não começa com %)
        return (
          nm_grupo.toLowerCase().startsWith(text) ||
          nm_prato.toLowerCase().startsWith(text) ||
          id_prato.toLowerCase().startsWith(text)
        );
      });
    },

    getFrequencyInfo: function (id_prato) {
      if(!id_prato) return "";
      const nr_semana = this.cardData?.dataCatalog?.tabela?.[this.dateIndex]?.nr_semana;
      const pratoInfo = this.cardData?.dataCatalog?.pratos?.[id_prato];
      const grupoInfo = this.cardData?.dataCatalog?.grupos?.[pratoInfo?.id_grupo];
      const freq_grupos = this.cardData?.dataCatalog?.freq_grupos?.[pratoInfo.id_grupo];
      const freq_pratos = this.cardData?.dataCatalog?.freq_pratos?.[id_prato];
      if(!freq_grupos && !freq_pratos) return;
      let text = "Frequencia:"
      if(freq_pratos){
        text += `<br>${this.$t('plate_used', { PARAM: `${pratoInfo.qt_utilizado}` })},  ${this.$t('this_week',{PARAM: `${pratoInfo.qt_utilizado_sem?.[nr_semana]||0}`})} 
                 <br>${this.$t('min_month', { PARAM: `${freq_pratos.qt_min_mes}` })}, ${this.$t('max_month', { PARAM: `${freq_pratos.qt_max_mes}` })}, ${this.$t('max_week', { PARAM: `${freq_pratos.qt_max_sem}` })}`;
      }
      if(freq_grupos){
        text += `<br>${this.$t('group_used', { PARAM: `${grupoInfo.qt_utilizado}` })},  ${this.$t('this_week',{PARAM: `${grupoInfo.qt_utilizado_sem?.[nr_semana]||0}`})} 
        <br>${this.$t('min_month', { PARAM: `${freq_grupos.qt_min_mes}` })}, ${this.$t('max_month', { PARAM: `${freq_grupos.qt_max_mes}` })}, ${this.$t('max_week', { PARAM: `${freq_grupos.qt_max_sem}` })}`;
      }
      return text;
    },

    loadDetail: function (plate) {
      if (!plate?.id_prato) return;
      this.chossPlate = plate;
      this.frequenciasPrato = this.getFrequencyInfo(this.chossPlate.id_prato);
      this.currentPlateValidations = this.validationMap?.get(this.chossPlate.id_prato) ?? [];
    },
    getPlateValue(tit, id_prato) {
      if (!id_prato) return "";

      const dataCatalog = this.cardData?.dataCatalog;
      if (!dataCatalog) return "";
      const dia = dataCatalog?.tabela?.[this.dateIndex];
      if(!dia) return "";
      const pratos = dataCatalog.pratos;
      const prato = pratos?.[id_prato];
      if (!prato) return "";
      
      let utilizacao_prato = null;
      if (this.coluna?.id_prato === id_prato) {
        utilizacao_prato =
          this.coluna?.utilizacao_prato ??
          PlateSubsController.getPlateUtilization(
            dia.data,
            prato.id_grupo,
            dia.id_feriado,
            dataCatalog?.utilizacao_grupo
          );
      }

      // resolvers dinâmicos (executa só o necessário)
      const resolvers = {
        nm_grupo: () =>
          dataCatalog.grupos?.[prato.id_grupo]?.nm_grupo,

        nm_prato: () => prato.nm_prato,

        id_prato: () => prato.id_prato,

        vlr_prato: () => prato.vlr_prato,

        id_pre_preparo: () => (prato.id_pre_preparo ? "S" : "N"),

        utilizacao_prato: () => utilizacao_prato,

        nm_atratividade: () =>
          dataCatalog.atratividade?.[prato.id_atratividade]?.nm_atratividade,

        nm_tipocorte: () =>
          dataCatalog.tipocorte?.[prato.id_tipocorte]?.nm_tipocorte,

        nm_modopreparo: () =>
          dataCatalog.modopreparo?.[prato.id_modopreparo]?.nm_modopreparo,

        nm_ingrediente_1: () =>
          dataCatalog.ingredientes?.[prato.id_ingrediente_1]?.nm_ingrediente,

        nm_ingrediente_2: () =>
          dataCatalog.ingredientes?.[prato.id_ingrediente_2]?.nm_ingrediente,

        nm_proteina: () =>
          dataCatalog.proteinas?.[prato.id_proteina]?.nm_proteina ?? "NA",
      };

      let val = resolvers[tit]?.();

      // mantém sua regra especial
      if (tit === "vlr_prato" && val != null) {
        val = parseFloat(val).toFixed(5);
      }

      return val ?? "";
    },
    getPlateData(tit, id_prato) {
      return (this.label[tit] || "") + this.getPlateValue(tit, id_prato);
    },
    trocarPrato: function () {
      const dataCatalog = this.cardData?.dataCatalog;
      const id_prato = this.coluna?.id_prato;
      const id_coluna = this.coluna?.id_coluna;
      if(!dataCatalog || !id_coluna || !this.chossPlate) return;
      
      PlateSubsController.changeCatalogPlate(dataCatalog, this.dateIndex, id_coluna, id_prato, this.chossPlate.id_prato);
      
      const tabelaAtual = dataCatalog?.tabela;
      const temTabela = Array.isArray(tabelaAtual) && tabelaAtual.length > 0;
      if (temTabela) {
        dataCatalog.Eventos = [];
        dataCatalog.Eventos = PlateSubsController.generateScenarioEvents(tabelaAtual, this.applyFeedback.categoria, this.applyFeedback.motivo);
      }      
      this.$emit("updateCenarioFromPlateSub", this.cardData);
      this.clearPlate();
    },
    closeModal: function () {
      this.resetDaysOfTheWeek();
      this.chossPlate = null;
      this.exchangePlate = false;
      this.inputChanged = false;
      this.copyDiners = false;
      this.pickedRadioChoice = 'percent';
      this.frequenciasPrato = "";
      this.currentPopupCollapsed = false;
      this.currentPopupCustomPosition = null;
      this.stopCurrentPopupDrag();
      this.is_visible = false;
    },
    clearPlate: function () {
      if(this.copyDiners){
        this.copyDiners = false;
        this.inputChanged = false;
        this.pickedRadioChoice = 'percent';
        this.resetDaysOfTheWeek();
        return;
      }
      
      if(this.exchangePlate){
        this.exchangePlate = false;
        return;
      }
      this.currentPlateValidations = [];
      this.closeModal();
    },
    editPlate: function () {
      const dataCatalog = this.cardData?.dataCatalog;
      const id_prato = this.coluna?.id_prato;
      const id_coluna = this.coluna?.id_coluna;
      if(!dataCatalog || !id_prato || !id_coluna ) return;
      
      PlateSubsController.updateCatalogConsumption(dataCatalog, this.dateIndex, id_coluna, this.old_perc_consumo);

      const tabelaAtual = dataCatalog?.tabela;
      const temTabela = Array.isArray(tabelaAtual) && tabelaAtual.length > 0;
      if (temTabela) {
        dataCatalog.Eventos = [];
        dataCatalog.Eventos = PlateSubsController.generateScenarioEvents(tabelaAtual, this.applyFeedback.categoria, this.applyFeedback.motivo);
      }      
      this.$emit("updateCenarioFromPlateSub", this.cardData);
      this.clearPlate();
    },
    editarprato: function () {
      this.showConfirmationModal();
    },
    deletePlate: function () {
      const dataCatalog = this.cardData?.dataCatalog;
      const id_prato = this.coluna?.id_prato;
      const id_coluna = this.coluna?.id_coluna;
      if(!dataCatalog || !id_prato || !id_coluna) return;
      
      PlateSubsController.changeCatalogPlate(dataCatalog, this.dateIndex, id_coluna, id_prato, null);
      
      const tabelaAtual = dataCatalog?.tabela;
      const temTabela = Array.isArray(tabelaAtual) && tabelaAtual.length > 0;
      if (temTabela) {
        dataCatalog.Eventos = [];
        dataCatalog.Eventos = PlateSubsController.generateScenarioEvents(tabelaAtual, this.applyFeedback.categoria, this.applyFeedback.motivo);
      }      
      this.$emit("updateCenarioFromPlateSub", this.cardData);
      this.clearPlate();
      this.closeModal();
    },

    showConfirmationModal: function () {
      this.applyFeedback.categoria = "";
      this.applyFeedback.motivo = "";
      this.showConfirmationError = false;
      this.$modal.show("feedbackConfirmationModal");
    },

    handleConfirmationConfirm: function () {
      if (this.exchangePlate) {
        this.trocarPrato();
      } else if (this.coluna?.id_prato != null) {
        this.editPlate();
      }
      this.closeModal();
      this.$modal.hide("feedbackConfirmationModal");
    },

    handleConfirmationCancel: function () {
      this.$modal.hide("feedbackConfirmationModal");
    },
  },
};
</script>

<style scoped lang="less">
@import (reference) url("../../assets/variables.less");
.overlay {
  position: fixed;
  z-index: 10;
  .full;
  background: rgba(0, 0, 0, 0.5);
}
.ovflw {
  max-width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
}

.frequencias {
  position: relative;
  display: block;
  margin-top: 8px;
  padding: 10px 12px;
  background: linear-gradient(180deg, #fbfcfe 0%, #f4f7fb 100%);
  border: 1px solid #d7dee8;
  border-radius: 8px;
  color: #2f3a66;
  font-size: 0.84rem;
  line-height: 1.4;
}

.button-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
  margin: 8px 0 2px;

  button {
    font-weight: 600;
    font-size: 0.84rem;
    box-shadow: 0 2px 8px rgba(19, 24, 41, 0.12);
    border-radius: 8px;
    border: 1px solid rgba(220, 20, 61, 0.22);
    color: white;
    transition: transform 0.15s ease, filter 0.15s ease, box-shadow 0.15s ease;
    background: #dc143d;
    padding: 8px 13px;
    margin: 0;
    min-height: 36px;
    cursor: not-allowed;
    opacity: 0.45;

    &:hover.hasprato {
      background: #212146;
      transform: translateY(-1px);
      box-shadow: 0 5px 12px rgba(19, 24, 41, 0.2);
    }
    &.hasprato {
      opacity: 1;
      cursor: pointer;
    }

    &:disabled {
      pointer-events: none;
    }
  }
}

.action-toolbar {
  position: sticky;
  top: 0;
  z-index: 3;
  background: linear-gradient(180deg, #ffffff 72%, rgba(255, 255, 255, 0.96) 100%);
  padding: 10px 0 11px;
  border-bottom: 1px solid #d7dee8;
  box-shadow: 0 4px 12px rgba(19, 24, 41, 0.08);
}

.labelForRadio{
  font-size: 0.9rem;
}

.prato-container {
  min-width: 0;
  z-index: 11;
  padding: 14px;
  position: fixed;
  left: 50%;
  top: 54%;
  transform: translate(-50%, -50%);
  border-radius: 12px;
  background: linear-gradient(180deg, #f3f6fd 0%, #ffffff 24%);
  width: 60%;
  max-width: 860px;
  max-height: 88vh;
  overflow: auto;
  box-shadow: 0 26px 44px rgba(10, 16, 35, 0.3);
  border: 1px solid rgba(33, 33, 70, 0.2);
  scrollbar-color: rgba(33, 33, 70, 0.6) rgba(33, 33, 70, 0.12);
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    width: 9px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(33, 33, 70, 0.12);
    border-radius: 999px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(33, 33, 70, 0.56);
    border-radius: 999px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(33, 33, 70, 0.72);
  }

  .tit {
    display: flex;
    padding: 10px 12px;
    color: white;
    font-size: 1.02rem;
    font-weight: 700;
    border-bottom: 1px solid rgba(33, 33, 70, 0.16);
    border-radius: 9px;
    background: #18224a;
    justify-content: space-between;
    align-items: center;

    .cell-location-tags {
      margin-top: 8px;
      display: flex;
      flex-wrap: wrap;
      gap: 6px;
      align-items: center;
    }

    .location-tag {
      display: inline-flex;
      align-items: center;
      max-width: 100%;
      border-radius: 999px;
      border: 1px solid rgba(255, 255, 255, 0.22);
      background: rgba(255, 255, 255, 0.16);
      color: #f4f7ff;
      font-size: 0.73rem;
      font-weight: 700;
      padding: 4px 10px;
      line-height: 1.2;
      box-shadow: 0 4px 10px rgba(19, 24, 41, 0.18);
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .tit-plate {
      display: inline-block;
      margin-left: 8px;
      padding: 2px 10px;
      border-radius: 999px;
      background: rgba(33, 33, 70, 0.14);
      color: #15255a;
      font-weight: 800;
      max-width: 520px;
      overflow: hidden;
      text-overflow: ellipsis;
      vertical-align: middle;
      white-space: nowrap;
    }
  }
  
  .copy-diners-content{
   min-height: fit-content; 
  }
  .sub-container {
    border-radius: 10px;
    position: relative;
    display: block;
    margin: 0 0 15px 0;
    max-height: 260px;
    box-shadow:
      inset 0 0 0 1px rgba(33, 33, 70, 0.11),
      0 6px 14px rgba(10, 16, 35, 0.07);
    background: linear-gradient(180deg, #f2f6ff 0%, #f8fbff 100%);

    overflow-x: hidden;
    overflow-y: scroll;
    padding: 8px 0;
    scrollbar-color: rgba(33, 33, 70, 0.56) rgba(33, 33, 70, 0.12);
    scrollbar-width: thin;

    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: rgba(33, 33, 70, 0.12);
      border-radius: 999px;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(33, 33, 70, 0.54);
      border-radius: 999px;
    }

    .plate {
      position: relative;
      overflow: hidden;
      border: 1px solid rgba(33, 33, 70, 0.08);
      padding: 6px 10px;
      display: grid;
      grid-template-columns: minmax(0, 1.1fr) minmax(92px, 0.6fr) minmax(0, 1.5fr);
      cursor: pointer;
      border-radius: 6px;

      transition: background 0.16s ease, border-color 0.16s ease;

      &:hover,
      &.active {
        border: 1px solid rgba(33, 33, 70, 0.38);
        background: #e2ebfb;
      }
      span {
        .ovflw;
        font-size: 0.79rem;
        color: #223064;
      }
      &:nth-of-type(2n) {
        background: rgba(33, 33, 70, 0.06);
      }
    }
    .validation-alert {
      position: absolute;
      right: 10px;
      text-align: center;
      top: 50%;
      transform: translateY(-50%);
      color: #d7263d;
      font-weight: 800;
      font-size: 14px;
      white-space: nowrap;
      pointer-events: none;
      width: 18px;
      height: 18px;
      border-radius: 999px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(215, 38, 61, 0.14);
      border: 1px solid rgba(215, 38, 61, 0.28);
    }
  }

  .sub-container-headline {
    display: grid;
    grid-template-columns: minmax(0, 1.1fr) minmax(92px, 0.6fr) minmax(0, 1.5fr);
    gap: 0;
    margin: 8px 4px 8px;
    padding: 6px 10px;
    border-radius: 8px;
    background: rgba(33, 33, 70, 0.08);
    border: 1px solid rgba(33, 33, 70, 0.12);

    span {
      font-size: 0.66rem;
      text-transform: uppercase;
      letter-spacing: 0.03em;
      color: #62709a;
      font-weight: 700;
      .ovflw;
    }
  }
  
  .sub-container-header{
    display: flex;
    align-items: end;
    gap: 5px;
    padding-left: 10px;
    
    h4{
      margin: 0;
    }
  }
  
  .radio-btn{
    display: flex;
  }
  
  .input-number {
    width: 5rem;
    text-align: center;
    border: 1px solid black;
    border-radius: 4px;
  }
  
  .sub-container-content{
    padding: 0 10px 8px;
    
    h4{
      /*font-weight: 400;*/
      margin: 10px 0 10px 0;
    }

    .exceptions {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 10px;
      /*max-width: 600px;*/
      padding-inline: 30px;
    }
    
    .exception-item {
      display: flex;
      gap: 5px;
      align-items: center;
    }
    
    .weekDay {
      width: 5rem;
      text-transform: capitalize;
      font-size: 0.9rem;
    }

  }
  
  .plateDetails {
    padding-bottom: 15px;
    .plate {
      display: grid;
      grid-template-columns: 50% 50%;
      background: linear-gradient(180deg, rgba(33, 33, 70, 0.12) 0%, rgba(33, 33, 70, 0.08) 100%);
      color: #1b2f66;
      padding: 5px 0;
      border-radius: 5px;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
    span {
      padding: 0 10px;
      display: block;
      .ovflw;
    }
  }

  .plate-exchage {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .exchange-layout {
    display: grid;
    gap: 12px;
    grid-template-columns: minmax(340px, 1.2fr) minmax(280px, 1fr);
    align-items: start;
  }

  .exchange-list,
  .exchange-preview {
    min-width: 0;
  }

  .exchange-preview {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .compare-card {
    border: 1px solid rgba(33, 33, 70, 0.16);
    border-radius: 12px;
    overflow: hidden;
    background: linear-gradient(180deg, #f7f9ff 0%, #ffffff 22%);
    box-shadow: 0 8px 18px rgba(10, 16, 35, 0.08);
  }

  .compare-title {
    margin: 0;
    padding: 9px 11px;
    font-size: 0.84rem;
    font-weight: 700;
    color: #15255a;
    background: linear-gradient(180deg, rgba(33, 33, 70, 0.16) 0%, rgba(33, 33, 70, 0.1) 100%);
    border-bottom: 1px solid rgba(33, 33, 70, 0.16);
  }

  .copy-diners {
    min-height: 0;
  }
}

.current-plate-popup {
  position: fixed;
  z-index: 22;
  overflow-y: auto;
  max-width: 300px;
  overflow-x: hidden;
  border-radius: 12px;
  box-shadow: 0 20px 34px rgba(10, 16, 35, 0.24);
  background: #ffffff;
  border: 1px solid rgba(33, 33, 70, 0.16);
  scrollbar-color: rgba(33, 33, 70, 0.56) rgba(33, 33, 70, 0.12);
  scrollbar-width: thin;

  .compare-card {
    border: 0;
    border-radius: 0;
    background: linear-gradient(180deg, rgba(244, 247, 255, 0.55) 0%, #ffffff 20%);
  }

  .current-popup-card {
    padding-bottom: 6px;
  }

  .popup-title-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    cursor: grab;
    user-select: none;
  }

  .collapse-toggle {
    border: 0;
    background: rgba(255, 255, 255, 0.14);
    color: #ffffff;
    width: 24px;
    height: 24px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.2s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.24);
    }
  }

  .compare-title {
    position: sticky;
    top: 0;
    z-index: 1;
    margin: 0;
  }

  .frequencias {
    border-left: 0;
    border-right: 0;
    border-bottom: 0;
    background: rgba(238, 242, 251, 0.7);
  }

  @media screen and (max-width: 460px) {
    .detail-fields {
      grid-template-columns: 1fr;
    }
  }

  &.is-collapsed {
    overflow: hidden;

    .current-popup-card {
      padding-bottom: 0;
    }
  }

  &.is-dragging {
    .popup-title-row {
      cursor: grabbing;
    }
  }
}

.detail-card {
  padding-bottom: 6px;

  .compare-title {
    padding: 8px 10px;
    font-size: 0.8rem;
    letter-spacing: 0.01em;
    color: white;
    background: #15255a;
    border-bottom: 1px solid rgba(33, 33, 70, 0.14);
  }

  .detail-fields {
    padding: 8px 10px 2px;
    display: grid;
    gap: 6px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .detail-field {
    border: 1px solid rgba(33, 33, 70, 0.16);
    border-radius: 8px;
    padding: 5px 7px;
    background: #f8faff;
  }

  .field-label {
    display: block;
    font-size: 0.66rem;
    line-height: 1.2;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    color: #5a6893;
    margin-bottom: 1px;
  }

  .field-value {
    display: block;
    font-size: 0.76rem;
    font-weight: 600;
    color: #1f2b56;
    line-height: 1.15;
    word-break: break-word;
  }

  .frequencias {
    border-left: 0;
    border-right: 0;
    border-bottom: 0;
    background: linear-gradient(180deg, rgba(230, 237, 252, 0.9) 0%, rgba(243, 247, 255, 0.95) 100%);
  }
}

.selection-placeholder {
  min-height: 180px;
  border-style: dashed;
  height: 400px;
  border-color: rgba(33, 33, 70, 0.28);
  background: linear-gradient(180deg, rgba(240, 245, 255, 0.6) 0%, rgba(255, 255, 255, 0.95) 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 14px 16px;

  .selection-placeholder-icon {
    font-size: 1.45rem;
    line-height: 1;
    margin-bottom: 8px;
  }

  h4 {
    margin: 0;
    color: #1f2b56;
    font-size: 0.92rem;
    font-weight: 800;
  }

  p {
    margin: 6px 0 0;
    color: #51608d;
    font-size: 0.8rem;
    line-height: 1.35;
    max-width: 280px;
  }
}

.main-detail-card {
  .main-consumption {
    margin: 4px 10px 2px;
    padding: 8px 10px;
    border: 1px solid rgba(33, 33, 70, 0.12);
    border-radius: 8px;
    background: rgba(33, 33, 70, 0.03);
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }

  .main-consumption-label {
    font-size: 0.72rem;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    color: #5a6893;
    font-weight: 700;
  }

  .main-consumption-value {
    font-size: 0.84rem;
    font-weight: 700;
    color: #1f2b56;
  }
}

.percConsumo {
  padding: 0 10px;
  input, span {
    /*max-width: 50px !important;*/
    display: inline-block !important;
    vertical-align: middle;
  }
}
.filter-input {
  margin-bottom: 15px;

  input {
    width: 96%;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 1rem;
    color: #333;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;

    &:focus {
      outline: none;
      border-color: #212146;
      box-shadow: 0 0 0 3px rgba(33, 33, 70, 0.12);
    }
  }
}

@media screen and (max-width: 1080px) {
  .prato-container {
    max-width: none;
    min-width: 0;
    padding: 12px;
  }

  .prato-container .sub-container-content .exceptions {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media screen and (max-width: 760px) {
  .prato-container {
    max-height: 92vh;
  }

  .prato-container .sub-container {
    max-height: 220px;
  }

  .prato-container .sub-container-content .exceptions {
    grid-template-columns: 1fr;
    padding-inline: 6px;
  }

  .button-container {
    justify-content: stretch;
  }

  .button-container button {
    flex: 1 1 auto;
    text-align: center;
  }
}

</style>
